export const CATEGORIES = [
  { slug: "politics", name: "Politics" },
  { slug: "business", name: "Business" },
  { slug: "finance", name: "Finance" },
  { slug: "tech", name: "Tech" },
  { slug: "ai", name: "AI" },
  { slug: "startups", name: "Startups" },
  { slug: "crypto", name: "Crypto" },
  { slug: "sports", name: "Sports" },
  { slug: "science", name: "Science" },
  { slug: "culture", name: "Culture" },
  { slug: "opinion", name: "Opinion" },
] as const;
